import { axios } from '@ben/api/axios';
import type { DropdownBase } from '../models/dropdown-base';

export const getDropdownOptions = async (modelName: string) => {
  const response = await axios.get<DropdownBase[]>(`${modelName}/`);
  return response?.data;
};
